// Source: app/scripts/controllers/auction-item.js
/**
 * Created by ristes on 20.4.15.
 */


Auction.controller('AuctionItemController', [
  '$scope',
  '$filter',
  '$routeParams',
  '$sce',
  '$modal',
  'toaster',
  'Auction',
  'Downloader',
  'Stomp',
  function ($scope, $filter, $routeParams, $sce, $modal, toaster, Auction, Downloader, Stomp) {

    Stomp("/topic/auction/", "all", subscribeForAllAuctions, $scope);

    function subscribeForAllAuctions(auction) {
      $scope.$apply(function () {
        if ($scope.entity.id == auction.id) {
          $scope.entity.status = auction.status;
        }
      });
    }

    $scope.downloadAnnouncement = function (auction) {
      Auction.getAnnouncement({
        id: auction.id
      }, function (data) {
        if (data && data.id) {
          Downloader.download('/data/rest/attachments/' + data.id);
        } else {
          toaster.pop('error', $filter('translate')('generic.error'),
            $filter('translate')("eauction.no_auction_anouncement"));
        }
      });
    }
  }
])
